import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.documentElement.classList.toggle(
      "dark",
      localStorage.theme === "dark" ||
        (!("theme" in localStorage) &&
          window.matchMedia("(prefers-color-scheme: dark)").matches)
    )
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", this.toggleTheme)
  }

  toggleTheme() {
    document.documentElement.classList.toggle(
      "dark",
      !document.documentElement.classList.contains("dark")
    )
    localStorage.theme = document.documentElement.classList.contains("dark")
      ? "dark"
      : "light"
  }

  inheritTheme() {
    localStorage.removeItem("theme")
    this.toggleTheme()
  }

  disconnect() {
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .removeEventListener("change", this.toggleTheme)
  }
}
